export default __webpack_public_path__ + "static/media/music-new.e6908287.mpeg";